































































































import { Component, Vue } from 'vue-property-decorator'
import { RedCapital, SelectedCountry } from '@/configuration'
import ShowLoading from "@/components/panel/ShowLoading.vue";
import Faq from '@/models/Faq';

@Component({
  metaInfo: {
    title: "RedCapital  | Plataforma de Financiamiento Digital ",
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    }
  },
  data(){
    return{
      search: '',
      faq:[
        {
          section: 'Inversiones',
          slug: 'inversiones',
          icon: "M11.9965 15.4808C11.5513 15.4808 11.1714 15.3223 10.8568 15.0052C10.5419 14.6882 10.3845 14.3072 10.3845 13.862C10.3845 13.4168 10.5431 13.0368 10.8602 12.722C11.1772 12.4073 11.5583 12.25 12.0035 12.25C12.4487 12.25 12.8286 12.4085 13.1432 12.7255C13.4581 13.0425 13.6155 13.4236 13.6155 13.8688C13.6155 14.3139 13.4569 14.6939 13.1398 15.0087C12.8228 15.3234 12.4417 15.4808 11.9965 15.4808ZM8.375 7.75H15.625L16.9 5.1615C17.041 4.89233 17.0349 4.63142 16.8818 4.37875C16.7286 4.12625 16.4988 4 16.1923 4H7.80775C7.50125 4 7.27142 4.12625 7.11825 4.37875C6.96508 4.63142 6.959 4.89233 7.1 5.1615L8.375 7.75ZM8.63075 20H15.3693C16.6556 20 17.7489 19.5497 18.6492 18.649C19.5497 17.7483 20 16.6529 20 15.3628C20 14.8239 19.9077 14.2992 19.723 13.7887C19.5385 13.2782 19.2718 12.8134 18.923 12.3942L15.8807 8.75H8.11925L5.077 12.3942C4.72817 12.8134 4.4615 13.2782 4.277 13.7887C4.09233 14.2992 4 14.8239 4 15.3628C4 16.6529 4.45033 17.7483 5.351 18.649C6.25167 19.5497 7.34492 20 8.63075 20Z",
          preguntas: [
            {
              pregunta: '¿Cómo invertir en RedCapital?',
              respuesta: `Sigue estos simples pasos para invertir en RedCapital: <br>
                          <ol>
                            <li>Ingresa a nuestro sitio web y registrate en <a href="/registrar">https://redcapital.cl/registrar</a></li>
                            <li>Revisa las oportunidades de inversión que tenemos para ti. Selecciona la que más se ajuste a tus necesidades y perfil de riesgo y sigue las instrucciones. </li>
                            <li>Paga tu inversión a través de Khipu o transferencia bancaria.</li>
                          </ol>
                          Validaremos tu transferencia y te enviaremos un correo electrónico confirmando tu participación en el proyecto. <br>
                          Puedes revisar el estado de tus inversiones y transferencias en tu perfil, menú “Mis inversiones” y “Transferencias pendientes”. `
            },
            {
              pregunta: ' ¿Cuáles son los requisitos para invertir?',
              respuesta: `Los requisitos para poder invertir a través de nuestra plataforma son: <br>
                          <ul style="list-style-type: '- ' ;">
                            <li>Ser mayor de 18 años.</li>
                            <li>Tener cédula de identidad chilena. (RUT)</li>
                            <li>Tener una cuenta bancaria en Chile.</li>
                          </ul>`
            },
            {
              pregunta: '¿Cuáles son los costos por invertir?',
              respuesta: `Costos de operación: se cobrará un 0,3% del monto de tu inversión una única vez, por cada mes que dure el proyecto. El detalle de este cobro lo puedes encontrar en tu contrato de inversionista. <br> <br>
                          Uso de la plataforma: Durante la vigencia del proyecto se cobrará un 0,06% mensual +IVA sobre el saldo insoluto de la inversión vigente. Este cobro se mantendrá hasta la fecha de pago de tu inversión a excepción de que exista un incumplimiento en el pago de esta. <br> <br>
                          Al registrarte en RedCapital, estarás aceptando las condiciones de estos cobros.`
            },
            {
              pregunta: '¿Por qué tengo que anticipar dinero en una adjudicación?',
              respuesta: `El anticipo de dinero garantiza la seriedad de tu participación. Si no te adjudicas el proyecto te devolveremos el dinero. `
            },
            {
              pregunta: '¿Cuánto debo esperar desde que decido invertir en un proyecto hasta que se adjudica? ',
              respuesta: `Eso depende de la fecha de inicio del proyecto, la que se muestra en el detalle de la oportunidad de inversión, junto con el plazo del proyecto y la fecha estimada de pago. <br>
                          Cumplida la fecha de inicio del proyecto, te informaremos el resultado de tu postulación en un plazo máximo de 24 horas hábiles. <br>
                          Recuerda que si participaste y no te adjudicaste el proyecto, el monto transferido será devuelto. 
                          `
            },
            {
              pregunta: '¿Si participo en un remate que no me adjudico: ¿Tiene algún costo?',
              respuesta: 'Si no se concreta la inversión no tiene ningún costo para el inversionista. '
            },
            {
              pregunta: '¿Qué pasa si la empresa en la que invertí no paga?',
              respuesta: `En esos casos, RedCapital velará porque se realicen todas las gestiones de cobranza pertinentes y que se hagan válidas las garantías asociadas`
            },
            {
              pregunta: '¿Qué significa diversificar?',
              respuesta: `La diversificación consiste en distribuir tu dinero entre diferentes inversiones para reducir el riesgo. Así, si una inversión pierde valor, otras pueden compensarla. La idea es evitar "poner todos los huevos en una sola canasta", de modo que una pérdida en un área sea compensada por el desempeño positivo en otra.`
            },
            {
              pregunta: '¿Puedo invertir como Sociedad?',
              respuesta: `Si, te solicitaremos RUT, Nombre y dirección de la sociedad. Si la cuenta corriente en donde se depositarán los pagos de las inversiones, no se encuentra a nombre de la sociedad, solicitaremos adicionalmente la escritura y poderes vigentes de la empresa, además de un “poder simple”, en donde el representante legal de la Sociedad autoriza el depósito en la cuenta definida. Esta información debe ser enviada a contacto@redcapital.cl`
            },
            {
              pregunta: ' Frente a la muerte del inversionista. ¿Los herederos pueden recuperar la inversión?',
              respuesta: `Si, en Chile, frente al fallecimiento de un inversionista, los herederos pueden recuperar la inversión, pero este proceso está sujeto a ciertos procedimientos legales y dependerá del tipo de inversión. <br>
                          Los herederos deberán realizar los trámites legales de la posesión efectiva, personalmente o representados por un mandatario, para que los dineros les sean entregados a ellos al vencimiento de las operaciones. <br>
                          Es recomendable que los herederos consulten con un abogado especializado en derecho sucesorio y/o un asesor financiero para asegurar que se cumplan todos los requisitos legales y fiscales asociados.
                          `
            },
            {
              pregunta: '¿Puedo anular mi inversión?',
              respuesta: `Si, podemos anular tu inversión.  En este caso procederemos con la devolución del valor que corresponde al “préstamo” de tu inversión, sin embargo, los “derechos” aportados por tu participación en el proyecto, no serán devueltos, ya que corresponde a la multa por la anulación.`
            },
            {
              pregunta: '¿Cuáles son las garantías que ofrecemos al inversionista?',
              respuesta: `Revisa las garantía que ofrecemos al inversionista en la sección <a href="/como-funciona-invertir">"Tipo de inversiones y posibles riesgos asociados"</a>`
            },
          ],
          filter: false,
        },
        {
          section: 'Proyectos publicados',
          slug: 'proy_publicados',
          icon: 'M7.00125 16.1538C7.21958 16.1538 7.40217 16.0799 7.549 15.9323C7.69583 15.7846 7.76925 15.6016 7.76925 15.3833C7.76925 15.1649 7.69542 14.9823 7.54775 14.8355C7.40008 14.6888 7.21708 14.6155 6.99875 14.6155C6.78042 14.6155 6.59783 14.6893 6.451 14.837C6.30417 14.9847 6.23075 15.1677 6.23075 15.386C6.23075 15.6043 6.30458 15.7869 6.45225 15.9338C6.59992 16.0804 6.78292 16.1538 7.00125 16.1538ZM7.00075 13.2308C7.14258 13.2308 7.26125 13.1828 7.35675 13.087C7.45225 12.9912 7.5 12.8724 7.5 12.7308V8.34625C7.5 8.20458 7.452 8.08583 7.356 7.99C7.26 7.89417 7.14108 7.84625 6.99925 7.84625C6.85742 7.84625 6.73875 7.89417 6.64325 7.99C6.54775 8.08583 6.5 8.20458 6.5 8.34625V12.7308C6.5 12.8724 6.548 12.9912 6.644 13.087C6.74 13.1828 6.85892 13.2308 7.00075 13.2308ZM11 14.5H17C17.1417 14.5 17.2604 14.452 17.3562 14.356C17.4521 14.26 17.5 14.1411 17.5 13.9993C17.5 13.8574 17.4521 13.7388 17.3562 13.6433C17.2604 13.5478 17.1417 13.5 17 13.5H11C10.8583 13.5 10.7396 13.548 10.6438 13.644C10.5479 13.74 10.5 13.8589 10.5 14.0008C10.5 14.1426 10.5479 14.2612 10.6438 14.3567C10.7396 14.4522 10.8583 14.5 11 14.5ZM11 10.5H17C17.1417 10.5 17.2604 10.452 17.3562 10.356C17.4521 10.26 17.5 10.1411 17.5 9.99925C17.5 9.85742 17.4521 9.73875 17.3562 9.64325C17.2604 9.54775 17.1417 9.5 17 9.5H11C10.8583 9.5 10.7396 9.548 10.6438 9.644C10.5479 9.74 10.5 9.85892 10.5 10.0008C10.5 10.1426 10.5479 10.2613 10.6438 10.3568C10.7396 10.4523 10.8583 10.5 11 10.5ZM4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H19.3845C19.8448 5 20.2292 5.15417 20.5375 5.4625C20.8458 5.77083 21 6.15517 21 6.6155V17.3845C21 17.8448 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8448 19 19.3845 19H4.6155Z',
          preguntas: [
            {
              pregunta: '¿Cuándo se publican nuevas oportunidades de inversión? ',
              respuesta: 'Publicamos oportunidades de inversión periódicamente. Revisa <a href="/invertir">aquí</a> las oportunidades de inversión disponibles'
            },
            {
              pregunta: '¿Qué sucede si invierto en un proyecto y para la fecha de inicio del proyecto, este no ha sido financiado al 100%?',
              respuesta: `En el caso de facturas, si los inversionistas no logran completar el financiamiento completo solicitado, RedCapital es quien invierte el monto faltante, por lo cual la operación se realizará de todos modos. <br>
                          En el caso de operaciones de crédito o leaseback, es fundamental que la operación esté 100% financiada para llevarse a cabo. Por lo tanto, si al inicio del proyecto no se ha completado el financiamiento, el la operación se postergará hasta que este esté garantizado. <br>
                          En este contexto, se recomienda no transferir el monto a invertir hasta recibir la confirmación oficial de la fecha de inicio del proyecto.
                          `
            }
          ],
          filter: false,
        },
        {
          section: 'Declarar inversiones',
          slug: 'declarar_inv',
          icon: 'M13.5093 21.6713L6.38428 19.5828V12.8463H8.46528C8.56911 12.8463 8.66653 12.8555 8.75753 12.874C8.84853 12.8927 8.93953 12.9187 9.03053 12.952L15.0518 15.1615C15.3234 15.2577 15.5622 15.4462 15.768 15.727C15.9739 16.0077 16.0768 16.2775 16.0768 16.5365C16.0768 16.7327 16.02 16.8846 15.9065 16.9923C15.793 17.1 15.642 17.1538 15.4535 17.1538H14.2518C13.8734 17.1538 13.5224 17.1305 13.1988 17.0838C12.8751 17.037 12.5774 16.9648 12.3055 16.8673L10.8728 16.3655C10.7651 16.3282 10.6606 16.3333 10.5593 16.3808C10.4581 16.4283 10.3909 16.4975 10.3575 16.5885C10.3242 16.6962 10.3325 16.802 10.3825 16.9058C10.4325 17.0096 10.5114 17.0801 10.619 17.1173L12.1903 17.6423C12.4928 17.7488 12.8184 17.8222 13.167 17.8625C13.5159 17.9029 13.8563 17.923 14.1883 17.923H19.346C19.8152 17.923 20.2081 18.0699 20.5248 18.3635C20.8414 18.657 20.9998 19.0359 20.9998 19.5L14.471 21.6595C14.3427 21.7007 14.1834 21.7222 13.993 21.724C13.8027 21.726 13.6414 21.7085 13.5093 21.6713ZM2.38428 19.923V13.923C2.38428 13.6167 2.48719 13.3606 2.69303 13.1548C2.89886 12.9491 3.15494 12.8463 3.46128 12.8463H4.30753C4.61386 12.8463 4.86994 12.9491 5.07578 13.1548C5.28144 13.3606 5.38428 13.6167 5.38428 13.923V19.923C5.38428 20.2295 5.28144 20.4856 5.07578 20.6913C4.86994 20.8971 4.61386 21 4.30753 21H3.46128C3.15494 21 2.89886 20.8971 2.69303 20.6913C2.48719 20.4856 2.38428 20.2295 2.38428 19.923ZM12.9248 9.64804L18.2653 4.33279C18.3588 4.23912 18.4693 4.19454 18.5968 4.19904C18.7244 4.20354 18.8369 4.25454 18.9343 4.35204C19.0279 4.44554 19.0748 4.56029 19.0748 4.69629C19.0748 4.83212 19.0279 4.94687 18.9343 5.04054L13.4903 10.4845C13.3286 10.6462 13.1401 10.727 12.9248 10.727C12.7094 10.727 12.5209 10.6462 12.3593 10.4845L9.74028 7.86554C9.64278 7.76804 9.59178 7.65004 9.58728 7.51154C9.58278 7.37304 9.63569 7.25512 9.74603 7.15779C9.84336 7.06412 9.96128 7.01954 10.0998 7.02404C10.2383 7.02854 10.3562 7.07954 10.4535 7.17704L12.9248 9.64804Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Debo pagar impuestos por mis inversiones al SII como personal natural?',
              respuesta: 'Sí, las inversiones pueden estar sujetas al pago de impuestos según la normativa vigente en Chile dependiendo del tipo de inversión y de los ingresos generados por esta. Si tus inversiones generan intereses, estos pueden estar gravados, dependiendo del monto y la naturaleza de la inversión, por lo que deben ser declarados al SII.'
            },
            {
              pregunta: '¿Cómo declaro mis ganancias al Servicio de Impuestos Internos como persona natural?',
              respuesta: 'Durante el primer trimestre de cada año, te enviaremos un certificado a tu correo con el detalle de los intereses recibidos por tus inversiones y la información relacionada entregada al SII. Esta información debería aparecer en tu propuesta de declaración de renta preparada por el mismo SII (Formulario 22).  En caso que no estuviera disponible, es responsabilidad de cada inversionista informar dichas rentas en su declaración.'
            },
            {
              pregunta: '¿Las empresas o sociedades deben pagar impuestos por sus inversiones?',
              respuesta: `Sí, las empresas y sociedades en Chile están sujetas al pago de impuestos por los intereses devengados, dependiendo de su régimen tributario y del tipo de ingresos generados. <br>
                          Es fundamental que la empresa lleve un registro contable claro y consulte con un asesor tributario para determinar cómo se deben declarar y pagar los impuestos correspondientes a los intereses devengados según el régimen tributario aplicable.
                          `
            },
            {
              pregunta: '¿Cómo declaro mis ganancias al SII como sociedad de inversión o empresa?',
              respuesta: 'Durante el primer trimestre de cada año, te enviaremos un certificado a tu correo con el detalle de la información de los intereses recibidos y devengados por las inversiones de tu empresa y la información relacionada entregada al SII.'
            },
            {
              pregunta: '¿Los intereses recibidos por los inversionistas son informados al servicio de impuestos internos (SII)?',
              respuesta: 'Si. En Marzo de cada año, se envía al SII el detalle de los intereses recibidos por cada inversionista durante el año anterior al que se está cursando. Esto debido a que es de carácter obligatorio para RedCapital completar la Declaración Jurada Anual Sobre Rentas Obtenidas por Terceros (Declaración Jurada N° 1932) del Servicio de Impuestos Internos (SII).'
            },
            {
              pregunta: 'Como inversionista, ¿debo declarar los ingresos recibidos por mis inversiones realizadas en la plataforma redcapital.cl?',
              respuesta: 'Si, el inversionista debe declarar los ingresos que recibe. Para realizar esto, en Marzo de cada año, RedCapital enviará a cada inversionista un informe con el detalle de los montos recibidos, y se cargará en la plataforma del SII el detalle de los intereses recibidos por cada inversionista durante el año anterior al que se está cursando.'
            }
          ],
          filter: false,
        },
        {
          section: 'Invertir en facturas',
          slug: 'invertir_facturas',
          icon: 'M6 21C5.43583 21 4.9615 20.8077 4.577 20.423C4.19233 20.0385 4 19.5642 4 19V17.8462C4 17.4019 4.15817 17.0216 4.4745 16.7052C4.79083 16.3889 5.17117 16.2308 5.6155 16.2308H7V4.6155C7 4.17117 7.15817 3.79083 7.4745 3.4745C7.79083 3.15817 8.17117 3 8.6155 3H18.3845C18.8288 3 19.2092 3.15817 19.5255 3.4745C19.8418 3.79083 20 4.17117 20 4.6155V19C20 19.5642 19.8077 20.0385 19.423 20.423C19.0385 20.8077 18.5642 21 18 21H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4.6155C19 4.436 18.9423 4.2885 18.827 4.173C18.7115 4.05767 18.564 4 18.3845 4H8.6155C8.436 4 8.2885 4.05767 8.173 4.173C8.05767 4.2885 8 4.436 8 4.6155V16.2308H15.3845C15.8288 16.2308 16.2092 16.3889 16.5255 16.7052C16.8418 17.0216 17 17.4019 17 17.8462V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9.8845 8.3845C9.74283 8.3845 9.62408 8.33658 9.52825 8.24075C9.43242 8.14475 9.3845 8.02583 9.3845 7.884C9.3845 7.74217 9.43242 7.6235 9.52825 7.528C9.62408 7.43233 9.74283 7.3845 9.8845 7.3845H17.1155C17.2572 7.3845 17.3759 7.4325 17.4718 7.5285C17.5676 7.6245 17.6155 7.74342 17.6155 7.88525C17.6155 8.02708 17.5676 8.14575 17.4718 8.24125C17.3759 8.33675 17.2572 8.3845 17.1155 8.3845H9.8845ZM9.8845 11.1538C9.74283 11.1538 9.62408 11.1058 9.52825 11.01C9.43242 10.914 9.3845 10.7951 9.3845 10.6533C9.3845 10.5114 9.43242 10.3927 9.52825 10.297C9.62408 10.2015 9.74283 10.1538 9.8845 10.1538H17.1155C17.2572 10.1538 17.3759 10.2017 17.4718 10.2977C17.5676 10.3937 17.6155 10.5127 17.6155 10.6545C17.6155 10.7963 17.5676 10.915 17.4718 11.0105C17.3759 11.106 17.2572 11.1538 17.1155 11.1538H9.8845Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Qué tipo de riesgos existen en el Factoring y cómo se minimizan?',
              respuesta: `Revisa los riesgos asociados a invertir en factoring en la sección "Tipo de inversiones y posibles riesgos asociados" (https://redcapital.cl/como-funciona-invertir)`
            },
            {
              pregunta: '¿Existe algún tipo de seguro para las facturas?',
              respuesta: `<p>Debido a que generalmente los seguros para facturas no cubren los riesgos relevantes, actualmente no contamos con estos. </p>
                          <p>Los seguros existentes en el mercado sólo cubren el riesgo de que el deudor quiebre y el riesgo de que no tenga posibilidad de pagar, pero no cubren el riesgo operativo, el cual es el principal riesgo de la industria. Este riesgo se mitiga con: </p>
                          <ul>
                            <li>Validación de los antecedentes de la empresa solicitante del préstamo.</li>
                            <li>Contrato y Pagaré de la empresa solicitante (responsabilidad de nuestro cliente). Dado esto, si no paga el deudor, paga el cliente.</li>
                            <li>Validación de la empresa deudora. Asegurando que el pago de la factura esté en buenas condiciones financieras.</li>
                            <li>Verificación de la factura (validando con el deudor que la factura será pagada).</li>
                          </ul>
                          <p>
                            Por otra parte, las compañías de seguro solo cubren a grandes deudores, donde si bien existe riesgo de quiebra, este es muy bajo. Pero estas compañías no cubren a los deudores más pequeños donde existe un riesgo mayor.
                          </p>
                          `
            },
            {
              pregunta: '¿RedCapital se hace responsable si no se verifica la factura?',
              respuesta: `<p>RedCapital siempre realiza las verificaciones de la factura con la empresa pagadora, pero no puede asegurar que la empresa anule dicha factura. Por esto es que siempre contamos con un contrato con la PYME para que responda en caso de algún problema con el pago. RedCapital realizará los máximos esfuerzos para recuperar los montos invertidos, pero no puede asegurar que se paguen dichos montos  ni la fecha exacta de pago.</p>`
            },
          ],
          filter: false,
        },
        {
          section: 'Pago de inversiones',
          slug: 'pago_inv',
          icon: 'M4.30788 18.6157C3.86355 18.6157 3.48322 18.4575 3.16688 18.141C2.85055 17.8246 2.69238 17.4444 2.69238 17.0002V8.69246C2.69238 8.55079 2.74038 8.43204 2.83638 8.33621C2.93238 8.24037 3.0513 8.19246 3.19313 8.19246C3.33497 8.19246 3.45363 8.24037 3.54913 8.33621C3.64463 8.43204 3.69238 8.55079 3.69238 8.69246V17.0002C3.69238 17.154 3.75647 17.295 3.88463 17.4232C4.01297 17.5515 4.15405 17.6157 4.30788 17.6157H17.8464C17.988 17.6157 18.1068 17.6636 18.2026 17.7595C18.2985 17.8555 18.3464 17.9744 18.3464 18.1162C18.3464 18.258 18.2985 18.3767 18.2026 18.4722C18.1068 18.5679 17.988 18.6157 17.8464 18.6157H4.30788ZM7.30788 15.6157C6.86355 15.6157 6.48322 15.4575 6.16688 15.141C5.85055 14.8246 5.69238 14.4444 5.69238 14.0002V6.84646C5.69238 6.40212 5.85055 6.02179 6.16688 5.70546C6.48322 5.38912 6.86355 5.23096 7.30788 5.23096H19.6924C20.1367 5.23096 20.517 5.38912 20.8334 5.70546C21.1497 6.02179 21.3079 6.40212 21.3079 6.84646V14.0002C21.3079 14.4444 21.1497 14.8246 20.8334 15.141C20.517 15.4575 20.1367 15.6157 19.6924 15.6157H7.30788ZM8.30788 14.6157C8.30788 14.1682 8.14972 13.787 7.83338 13.4722C7.51705 13.1575 7.13672 13.0002 6.69238 13.0002V14.0002C6.69238 14.1669 6.7533 14.3111 6.87513 14.433C6.99697 14.5548 7.14122 14.6157 7.30788 14.6157H8.30788ZM18.6924 14.6157H19.6924C19.859 14.6157 20.0033 14.5548 20.1251 14.433C20.247 14.3111 20.3079 14.1669 20.3079 14.0002V13.0002C19.8604 13.0002 19.4793 13.1584 19.1646 13.4747C18.8498 13.791 18.6924 14.1714 18.6924 14.6157ZM13.5001 12.4232C14.0643 12.4232 14.5386 12.231 14.9231 11.8465C15.3078 11.4618 15.5001 10.9874 15.5001 10.4232C15.5001 9.85921 15.3078 9.38487 14.9231 9.00021C14.5386 8.61554 14.0643 8.42321 13.5001 8.42321C12.936 8.42321 12.4616 8.61554 12.0771 9.00021C11.6925 9.38487 11.5001 9.85921 11.5001 10.4232C11.5001 10.9874 11.6925 11.4618 12.0771 11.8465C12.4616 12.231 12.936 12.4232 13.5001 12.4232ZM6.69238 7.84646C7.13988 7.84646 7.52097 7.68829 7.83563 7.37196C8.15047 7.05546 8.30788 6.67512 8.30788 6.23096H7.30788C7.14122 6.23096 6.99697 6.29187 6.87513 6.41371C6.7533 6.53554 6.69238 6.67979 6.69238 6.84646V7.84646ZM20.3079 7.84646V6.84646C20.3079 6.67979 20.247 6.53554 20.1251 6.41371C20.0033 6.29187 19.859 6.23096 19.6924 6.23096H18.6924C18.6924 6.67846 18.8505 7.05954 19.1669 7.37421C19.4832 7.68904 19.8635 7.84646 20.3079 7.84646Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Cuál es la fecha de pago de los proyectos?',
              respuesta: `<p>La fecha estimada de pago de cada inversión está indicada en el detalle de la misma. Sin embargo, es necesario tener presente que puede haber retrasos, por lo que esta fecha puede variar. </p>`
            },
            {
              pregunta: '¿Dónde puedo revisar los montos pendientes a transferir en mis inversiones?',
              respuesta: `<p>Debes ingresar a tu cuenta , ir al menú “Mis inversiones” y luego ir a “Transferencias pendientes". Desde ahí también puedes confirmar el pago de saldos pendientes de cualquiera de tus inversiones. </p>`
            },
          ],
          filter: false,
        },
        {
          section: 'Transferencias',
          slug: 'transferencias',
          icon: 'M12.1501 16.5345C12.7386 16.5345 13.2896 16.3798 13.8031 16.0703C14.3164 15.7606 14.5731 15.2538 14.5731 14.55C14.5731 13.9897 14.3881 13.5499 14.0183 13.2308C13.6485 12.9116 12.9257 12.5539 11.8501 12.1578C10.7771 11.7692 10.0146 11.359 9.56256 10.927C9.11056 10.4948 8.88456 9.91917 8.88456 9.2C8.88456 8.59367 9.11248 8.03375 9.56831 7.52025C10.0241 7.00675 10.6796 6.68592 11.5346 6.55775V5.875C11.5346 5.74417 11.5836 5.62975 11.6818 5.53175C11.7798 5.43358 11.8942 5.3845 12.0251 5.3845C12.1559 5.3845 12.2703 5.43358 12.3683 5.53175C12.4665 5.62975 12.5156 5.74417 12.5156 5.875V6.55775C12.9732 6.59108 13.403 6.73433 13.8048 6.9875C14.2068 7.24067 14.5392 7.56275 14.8021 7.95375C14.8674 8.04742 14.8757 8.14717 14.8271 8.253C14.7782 8.35867 14.6949 8.43392 14.5771 8.47875C14.4629 8.52375 14.3456 8.53208 14.2251 8.50375C14.1046 8.47558 14.0033 8.40833 13.9213 8.302C13.7033 8.03783 13.4405 7.824 13.1328 7.6605C12.8251 7.49717 12.4642 7.4155 12.0501 7.4155C11.3897 7.4155 10.8606 7.58533 10.4626 7.925C10.0646 8.26467 9.86556 8.68967 9.86556 9.2C9.86556 9.71033 10.0187 10.1033 10.3251 10.3788C10.6314 10.6544 11.3359 10.9846 12.4386 11.3693C13.6386 11.8026 14.4514 12.266 14.8771 12.7595C15.3027 13.2532 15.5156 13.85 15.5156 14.55C15.5156 15.0205 15.4226 15.4327 15.2366 15.7865C15.0507 16.1403 14.8106 16.4336 14.5163 16.6663C14.2221 16.8991 13.8949 17.0786 13.5346 17.2048C13.1744 17.3311 12.8181 17.4103 12.4656 17.4423V18.125C12.4656 18.2558 12.4165 18.3703 12.3183 18.4683C12.2203 18.5664 12.1059 18.6155 11.9751 18.6155C11.8442 18.6155 11.7298 18.5664 11.6318 18.4683C11.5336 18.3703 11.4846 18.2558 11.4846 18.125V17.3923C10.8897 17.2589 10.3673 17.0313 9.91731 16.7095C9.46731 16.3878 9.09614 15.9565 8.80381 15.4155C8.74231 15.2975 8.73689 15.175 8.78756 15.048C8.83823 14.9212 8.92256 14.8353 9.04056 14.7905C9.15456 14.7455 9.27506 14.7433 9.40206 14.7838C9.52889 14.8241 9.62506 14.8993 9.69056 15.0095C9.97506 15.4942 10.3286 15.8695 10.7511 16.1355C11.1734 16.4015 11.6397 16.5345 12.1501 16.5345ZM12.0001 22C9.96673 22 8.14431 21.4596 6.53281 20.3788C4.92131 19.2981 3.71164 17.8442 2.90381 16.0173V18.8078C2.90381 18.9501 2.85606 19.069 2.76056 19.1645C2.66506 19.26 2.54614 19.3078 2.40381 19.3078C2.26164 19.3078 2.14273 19.26 2.04706 19.1645C1.95156 19.069 1.90381 18.9501 1.90381 18.8078V15.1155C1.90381 14.8833 1.98048 14.6907 2.13381 14.5375C2.28698 14.3843 2.47956 14.3077 2.71156 14.3077H6.40381C6.54614 14.3077 6.66506 14.3555 6.76056 14.451C6.85606 14.5465 6.90381 14.6654 6.90381 14.8077C6.90381 14.9501 6.85606 15.069 6.76056 15.1645C6.66506 15.26 6.54614 15.3077 6.40381 15.3077H3.69806C4.34423 17.0206 5.42723 18.3975 6.94706 19.4385C8.46706 20.4795 10.1514 21 12.0001 21C14.2987 21 16.2907 20.2488 17.9761 18.7463C19.6612 17.2436 20.6461 15.3378 20.9308 13.0288C20.9513 12.8776 21.0103 12.7517 21.1078 12.651C21.2051 12.5503 21.3295 12.5 21.4808 12.5C21.6231 12.5 21.7398 12.5554 21.8308 12.6663C21.9218 12.7773 21.9571 12.9064 21.9366 13.0538C21.8071 14.3166 21.4596 15.49 20.8943 16.574C20.329 17.658 19.6027 18.6029 18.7156 19.4088C17.8282 20.2144 16.8112 20.8477 15.6646 21.3088C14.5177 21.7696 13.2962 22 12.0001 22ZM12.0001 3C9.77823 3 7.80864 3.72883 6.09131 5.1865C4.37414 6.64417 3.36681 8.566 3.06931 10.952C3.04881 11.1032 2.98981 11.2323 2.89231 11.3395C2.79498 11.4465 2.67064 11.5 2.51931 11.5C2.36414 11.5 2.24423 11.4446 2.15956 11.3338C2.07506 11.2228 2.04306 11.0872 2.06356 10.927C2.21873 9.61283 2.58856 8.41058 3.17306 7.32025C3.75773 6.22975 4.49364 5.29125 5.38081 4.50475C6.26797 3.71825 7.27856 3.10417 8.41256 2.6625C9.54656 2.22083 10.7424 2 12.0001 2C13.9949 2 15.8173 2.54358 17.4673 3.63075C19.1173 4.71792 20.327 6.19417 21.0963 8.0595V5.19225C21.0963 5.04992 21.1441 4.931 21.2396 4.8355C21.3351 4.74 21.454 4.69225 21.5963 4.69225C21.7385 4.69225 21.8574 4.74 21.9531 4.8355C22.0486 4.931 22.0963 5.04992 22.0963 5.19225V8.8845C22.0963 9.11667 22.0196 9.30933 21.8663 9.4625C21.7131 9.61567 21.5206 9.69225 21.2886 9.69225H17.5963C17.454 9.69225 17.3351 9.6445 17.2396 9.549C17.1441 9.4535 17.0963 9.33458 17.0963 9.19225C17.0963 9.04992 17.1441 8.931 17.2396 8.8355C17.3351 8.74 17.454 8.69225 17.5963 8.69225H20.3021C19.6944 7.03075 18.6274 5.66667 17.1011 4.6C15.5747 3.53333 13.8744 3 12.0001 3Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Qué pasa si mi banco tiene un tope de dinero diario para realizar transferencias?',
              respuesta: `
                  <p>
                   Si el monto de tu inversión supera el límite máximo de transferencia de tu banco, deberás realizar
                   múltiples transferencias hasta completar el total a invertir.
                   <br>
                   Por favor, recuerda enviarnos los comprobantes de cada transferencia indicando el ID de la inversión,
                   al correo <a href="mailto:contacto@redcapital.cl">contacto@redcapital.cl</a>.
                  </p>
              `
            },
            {
              pregunta: '¿Cómo pago mi primera inversión?',
              respuesta: `
                <p>Puedes pagar tu inversión vía transferencia bancaria o Khipu. </p>
                <p>
                  Si optas por pagar tu inversión vía transferencia bancaria, en tu primera inversión, por motivos de seguridad, algunos bancos no permiten transferir el monto total de esta. Tendrás 72 horas para transferir el saldo pendiente de tu inversión.  Te proporcionaremos un código de inversión el cual debes incluir en el detalle de cada transferencia que realices. 
                </p>
                <p>
                En caso de no pago del saldo pendiente de tu inversión, te devolvemos el dinero o abono transferido descontando los derechos de participación del proyecto.
                </p>
              `
            },
            {
              pregunta: 'Transferí el monto de mi inversión hace menos de 24 horas y aún se encuentra pendiente.',
              respuesta: `<p>Si has realizado el pago de tu inversión a través de transferencia bancaria, esta se verificará y aprobará dentro de un plazo de 24 horas hábiles. Para una aprobación más rápida, te recomendamos usar Khipu, que garantiza una aprobación en línea con la seguridad de una transferencia bancaria.</p>`
            },
            {
              pregunta: 'Transferí el monto de mi inversión hace más de 24 horas y aún se encuentra pendiente.',
              respuesta: `
                <p>
                  Si realizaste el pago de tu inversión por transferencia y esta aún no ha sido aprobada, por favor envíanos un mensaje a contacto@redcapital.cl indicando el código de inversión para que podamos revisarlo y validar el estado de tu transferencia.
                </p>
                <p>
                  Para una aprobación más rápida, te recomendamos usar Khipu, que garantiza una aprobación en línea con la seguridad de una transferencia bancaria.
                </p>  
              `
            },
          ],
          filter: false,
        },
        {
          section: 'Rentabilidad',
          slug: 'rentabilidad',
          icon: 'M3.35382 16.8943C3.24366 16.784 3.19274 16.665 3.20107 16.5375C3.20941 16.41 3.26032 16.2995 3.35382 16.2058L8.16732 11.3365C8.47382 11.0174 8.85266 10.8578 9.30382 10.8578C9.75516 10.8578 10.1404 11.0174 10.4596 11.3365L12.8808 13.7635C12.9962 13.8789 13.1372 13.9365 13.3038 13.9365C13.4705 13.9365 13.618 13.8789 13.7463 13.7635L19.3308 8.24805H16.5001C16.3577 8.24805 16.2388 8.2003 16.1433 8.1048C16.0478 8.0093 16.0001 7.89038 16.0001 7.74805C16.0001 7.60571 16.0478 7.4868 16.1433 7.3913C16.2388 7.2958 16.3577 7.24805 16.5001 7.24805H20.1923C20.4245 7.24805 20.6172 7.32471 20.7703 7.47805C20.9235 7.63121 21.0001 7.8238 21.0001 8.0558V11.748C21.0001 11.8904 20.9523 12.0093 20.8568 12.1048C20.7613 12.2003 20.6424 12.248 20.5001 12.248C20.3577 12.248 20.2388 12.2035 20.1433 12.1145C20.0478 12.0254 20.0001 11.9096 20.0001 11.7673V8.9558L14.4406 14.5155C14.1341 14.8219 13.7552 14.975 13.3038 14.975C12.8527 14.975 12.4738 14.8219 12.1673 14.5155L9.74633 12.0943C9.63083 11.979 9.48332 11.9213 9.30382 11.9213C9.12432 11.9213 8.97691 11.979 8.86157 12.0943L4.06157 16.8943C3.95524 17.0006 3.83732 17.0538 3.70782 17.0538C3.57832 17.0538 3.46032 17.0006 3.35382 16.8943Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Qué es la TIR?',
              respuesta: `<p>La Tasa Interna de Retorno (TIR) es un indicador financiero que se usa para evaluar la rentabilidad de una inversión. Esta tasa ya considera cualquier comisión cobrada por RedCapital por participar en la inversión y se muestra de forma anualizada, para que sea más fácil compararla con la de otras inversiones con distintos plazos de duración. A mayor TIR, mayor rentabilidad.  Pero es necesario recordar que mayor rentabilidad generalmente implica más riesgo, por lo que es fundamental diversificar y conocer tu perfil de riesgo.</p>`
            },
            {
              pregunta: '¿Cuánto puedo ganar al invertir en RedCapital? ',
              respuesta: `
              <p>La rentabilidad esperada de cada oportunidad de inversión publicada en nuestra plataforma, está indicada en cada una de ellas, y varía según el tipo de proyecto. Esta depende de muchos factores tales como el riesgo y el plazo del proyecto.  Por lo mismo te sugerimos siempre diversificar tus inversiones.</p>
              <p>Recuerda que la rentabilidad es variable y que rentabilidades pasadas no garantizan rentabilidades futuras.</p>
              `
            },
            {
              pregunta: '¿Cómo se calcula la rentabilidad de un proyecto (TIR) y la TIR real?',
              respuesta: `
              <p>
                Redcapital siempre publica la rentabilidad anualizada para que se pueda comparar los distintos plazos de pago.
              </p>
              <p>
               Para calcular la TIR, RedCapital utiliza la fórmula de Excel "TIR.NO.PER.". Esta fórmula se utiliza habitualmente en la industria, considerando que sirve para distintos tipos de flujos, períodos, formas de pago, adelantos de cuotas, etc.
              </p>
              <p>
                Para el cálculo de la TIR utilizamos los montos reales transferidos por el inversionista (incluidos nuestros costos) y los montos estimados a recibir. Por lo tanto, la TIR considera el flujo real del inversionista, lo que transfiere versus lo que recibe.
              </p>
              <p>
                En la plataforma de RedCapital, en el panel del inversionista, se publican "TIR PPTO" y "TIR REAL". La primera es lo que se estima que recibiría el inversionista según la negociación original con la PYME; la segunda es la rentabilidad recibida final.
              </p>
              <p>
              Redcapital siempre publica la rentabilidad anualizada para que se puedan comparar inversiones con distintos plazos de pago.
              </p>
              `
            },
            {
              pregunta: '¿Desde cuándo comienzan a correr los intereses?',
              respuesta: `
                <p>
                  Los intereses comienzan a regir desde la "fecha de inicio del proyecto", salvo que el inversionista transfiera posterior a dicha fecha. 
                </p>
                <p>
                  De haber cupo y un usuario invierte después de la "fecha de inicio de proyecto", los intereses comienzan desde que transfiere el monto total. 
                </p>
                <p>
                  En el caso de créditos y Leasebacks, puede ocurrir que la fecha de inicio de proyecto se modifique, y que el proyecto comience más tarde a lo inicialmente proyectado.  En estos casos, te recomendamos inicialmente solo reservar tu participación en el proyecto, transfiriendo sólo los derechos y, una vez notificado de la fecha final de inicio, transferir el saldo de tu inversión.  De esta forma, no afectarás tu rentabilidad. Estos proyectos pueden partir algunos días después de la fecha original, considerando que la Pyme solicitante debe firmar ante notario, proceso que se puede retrasar por varios motivos. En el caso de factoring, los contratos están firmados con anterioridad, las facturas están cedidas y verificadas antes de publicarlas.
                </p>
              `
            },
          ],
          filter: false,
        },
        {
          section: 'Solicitar crédito',
          slug: 'solicitar_credito',
          icon: 'M8 13H5.94225C5.81542 13 5.71 13.042 5.626 13.126C5.542 13.21 5.5 13.3154 5.5 13.4423C5.5 13.5693 5.542 13.6748 5.626 13.7588C5.71 13.8426 5.81542 13.8845 5.94225 13.8845H8.1155C8.32183 13.8845 8.50158 13.8079 8.65475 13.6548C8.80792 13.5016 8.8845 13.3218 8.8845 13.1155V11.5192C8.8845 11.3127 8.80792 11.1329 8.65475 10.9798C8.50158 10.8266 8.32183 10.75 8.1155 10.75H6.3845V9.3845H8.44225C8.56925 9.3845 8.67475 9.34258 8.75875 9.25875C8.84258 9.17475 8.8845 9.06925 8.8845 8.94225C8.8845 8.81542 8.84258 8.71 8.75875 8.626C8.67475 8.542 8.56925 8.5 8.44225 8.5H5.94225C5.81542 8.5 5.71 8.542 5.626 8.626C5.542 8.71 5.5 8.81542 5.5 8.94225V11.1923C5.5 11.3193 5.542 11.4248 5.626 11.5088C5.71 11.5926 5.81542 11.6345 5.94225 11.6345H8V13ZM15 12.923C13.9667 12.923 13.1571 13.083 12.5712 13.403C11.9852 13.7228 11.6923 14.1744 11.6923 14.7578V14.9038C11.6923 15.0116 11.7327 15.1058 11.8135 15.1865C11.8942 15.2673 11.9884 15.3077 12.0963 15.3077H17.9038C18.0116 15.3077 18.1058 15.2673 18.1865 15.1865C18.2673 15.1058 18.3077 15.0116 18.3077 14.9038V14.7578C18.3077 14.1744 18.0148 13.7228 17.4288 13.403C16.8429 13.083 16.0333 12.923 15 12.923ZM15 11.6923C15.4218 11.6923 15.7773 11.5478 16.0663 11.2588C16.3554 10.9696 16.5 10.6141 16.5 10.1923C16.5 9.77042 16.3554 9.415 16.0663 9.126C15.7773 8.83683 15.4218 8.69225 15 8.69225C14.5782 8.69225 14.2227 8.83683 13.9337 9.126C13.6446 9.415 13.5 9.77042 13.5 10.1923C13.5 10.6141 13.6446 10.9696 13.9337 11.2588C14.2227 11.5478 14.5782 11.6923 15 11.6923ZM4.6155 18C4.15517 18 3.77083 17.8458 3.4625 17.5375C3.15417 17.2292 3 16.8448 3 16.3845V7.6155C3 7.15517 3.15417 6.77083 3.4625 6.4625C3.77083 6.15417 4.15517 6 4.6155 6H19.3845C19.8448 6 20.2292 6.15417 20.5375 6.4625C20.8458 6.77083 21 7.15517 21 7.6155V16.3845C21 16.8448 20.8458 17.2292 20.5375 17.5375C20.2292 17.8458 19.8448 18 19.3845 18H4.6155Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Cuáles son los pasos para solicitar un crédito en RedCapital?',
              respuesta: `
              <p>
                1. Si no eres cliente <a href="/registrar">regístrate</a> en RedCapital.
                <ul>
                  <li>Debes cumplir con los <a href="#" id="goToRequisitos">requisitos</a></li>
                  <li>Elige el monto a invertir en el proyecto seleccionado y verás la simulación</li>
                </ul>
              </p>

              <p>
                2. Completa el formulario de solicitud de crédito (podrás ir guardando mientras consigues la información).
                <ul>
                  <li>Deberás completar datos de la empresa y solicitantes</li>
                  <li>Cargar los documentos requeridos de la empresa</li>
                  <li>Para brindar la mejor opción de crédito para tu empresa. Debes entregar fotos de la empresa y una breve descripción de porque necesitas el crédito, entre otros.</li>
                </ul>
              </p>

              <p>
                3. Una vez recibida la solicitud, te asesoramos en el proceso y validamos la información y las garantías asociadas. 
                <ul>
                  <li>
                    Un ejecutivo comercial de RedCapital se comunicará contigo vía teléfono o mail, en un plazo no superior a 24 horas hábiles.
                  </li>
                </ul>
              </p>

              <p>
                4. Publicaremos tu solicitud y adjudicaremos a las mejores propuestas de los inversionistas. Te recomendamos:
                <ul>
                  <li>
                    Contestar consultas de inversionistas  para una rápida adjudicación. Los inversionistas pueden realizar preguntas o tener inquietudes acerca de la empresa o motivo del préstamo.  Tu agilidad y sinceridad en este paso te permitirá obtener mejores tasas y en forma más rápida.
                  </li>
                  <li>
                    Aceptar condiciones del pago del crédito. En tu cuenta, en la opción “mis solicitudes de créditos”, debes aceptar la condición.
                  </li>
                </ul>
              </p>
              <p>
                Firmaremos el pagaré y te entregaremos el monto solicitado
              </p>

              <table class="info__table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Firma Pagaré</th>
                    <th>Entrega de monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Santiago</td>
                    <td>Nos contactaremos contigo para acordar día y hora para la firma del pagaré en notaría.</td>
                    <td>Se transfiere el mismo día que firma el pagaré.</td>
                  </tr>
                  <tr>
                    <td>Regiones</td>
                    <td>Nos contactaremos contigo para enviarte el pagaré al domicilio que hayas fijado en tu perfil. Los costos por concepto de envío, notaría y de impuestos serán de cargo del solicitante y deberá pagarse en la notaría que más te acomode.</td>
                    <td>Se transfiere el día en que RedCapital le llega el pagaré.</td>  
                  </tr>
                </tbody>
              </table>

              <p>
                IMPORTANTE: Recibirás un correo automático una vez adjudicado con las fechas y montos a depositar.
              </p>

              <ul>
                <li>Deberás transferir dichos montos a nuestra cuenta antes del vencimiento.</li>
              </ul>

              `
            },
            {
              pregunta: '<div id="requisitos">¿Cuáles son los requisitos para solicitar un crédito en RedCapital?</div>',
              respuesta: `
                <ol style="list-style-type: ' - '">
                  <li>El monto mínimo a solicitar es de $5.000.000. </li>
                  <li>El solicitante de financiamiento debe ser el representante legal de la empresa. </li>
                  <li>Tener al menos un balance anual, declaración de renta y los últimos 12 IVAs declarados. </li>
                </ol>
              `
            },
            {
              pregunta: '¿Cuál es el beneficio al solicitar un crédito en RedCapital?',
              respuesta: `
              <p>
                Obtener en forma mucho más rápida un crédito con una mejor tasa que en el mercado financiero tradicional. Los inversionistas compiten por entregarte la mejor tasa.</p>
              </p>
              `
            },
          ],
          filter: false,
        },
        {
          section: 'Pago de cuotas',
          slug: 'pago_cuotas',
          icon: 'M19.5 18.5H17C16.8583 18.5 16.7396 18.452 16.6438 18.356C16.5479 18.26 16.5 18.1411 16.5 17.9992C16.5 17.8574 16.5479 17.7387 16.6438 17.6432C16.7396 17.5477 16.8583 17.5 17 17.5H19.5V15C19.5 14.8583 19.548 14.7396 19.644 14.6438C19.74 14.5479 19.8589 14.5 20.0008 14.5C20.1426 14.5 20.2612 14.5479 20.3568 14.6438C20.4523 14.7396 20.5 14.8583 20.5 15V17.5H23C23.1417 17.5 23.2604 17.548 23.3563 17.644C23.4521 17.74 23.5 17.8589 23.5 18.0008C23.5 18.1426 23.4521 18.2613 23.3563 18.3568C23.2604 18.4523 23.1417 18.5 23 18.5H20.5V21C20.5 21.1417 20.452 21.2604 20.356 21.3563C20.26 21.4521 20.1411 21.5 19.9993 21.5C19.8574 21.5 19.7388 21.4521 19.6432 21.3563C19.5477 21.2604 19.5 21.1417 19.5 21V18.5ZM4 11.1923H20V8.80775H4V11.1923ZM4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H19.3845C19.8448 5 20.2292 5.15417 20.5375 5.4625C20.8458 5.77083 21 6.15517 21 6.6155V11.6923C21 11.9211 20.9226 12.1129 20.7678 12.2677C20.6129 12.4226 20.4211 12.5 20.1923 12.5H19.5C18.1167 12.5 16.9375 12.9875 15.9625 13.9625C14.9875 14.9375 14.5 16.1167 14.5 17.5V18.1923C14.5 18.4211 14.4226 18.6129 14.2678 18.7678C14.1129 18.9226 13.9211 19 13.6923 19H4.6155Z',
          img: '',
          preguntas: [
            {
              pregunta: '¿Donde puede revisar el detalle de mi cuota? ',
              respuesta: `
              <p>
                En tu cuenta de RedCapital  tendrás acceso a un panel con el detalle del pago de cuotas, por fecha, vencimientos, estatus, entre otros.A pesar de que utilizamos todos los mecanismos de recordatorio para que este pago sea efectivo tú tienes la última responsabilidad de que el pago se realice. Por lo mismo, te pedimos estar atento y comunicado con nosotros
              </p>
              <p>
                Puedes hacer pagos anticipados de tus cuotas.
              </p>
              <p>
                Una vez que pagas la última cuota, tu crédito ha cerrado exitosamente su ciclo.
              </p>
              `
            }
          ],
          filter: false,
        },
        {
          section: 'Reclamos',
          slug: 'reclamos',
          icon: 'M20.6537 12.4998H18.4229C18.2813 12.4998 18.1625 12.4518 18.0667 12.3558C17.9709 12.2598 17.9229 12.1408 17.9229 11.999C17.9229 11.8572 17.9709 11.7385 18.0667 11.643C18.1625 11.5475 18.2813 11.4998 18.4229 11.4998H20.6537C20.7954 11.4998 20.9141 11.5478 21.0099 11.6438C21.1058 11.7398 21.1537 11.8587 21.1537 12.0005C21.1537 12.1423 21.1058 12.261 21.0099 12.3565C20.9141 12.452 20.7954 12.4998 20.6537 12.4998ZM16.7344 16.6268C16.8243 16.5088 16.9352 16.4395 17.0672 16.419C17.1994 16.3985 17.3244 16.4331 17.4422 16.5228L19.2154 17.8575C19.3333 17.9472 19.4024 18.0581 19.4229 18.1903C19.4434 18.3223 19.4089 18.4473 19.3192 18.5653C19.2294 18.6831 19.1184 18.7523 18.9864 18.7728C18.8544 18.7933 18.7294 18.7587 18.6114 18.669L16.8384 17.3343C16.7204 17.2446 16.6512 17.1338 16.6307 17.0018C16.6102 16.8696 16.6448 16.7446 16.7344 16.6268ZM19.1384 6.06526L17.3654 7.39977C17.2474 7.48943 17.1224 7.52402 16.9904 7.50352C16.8583 7.48302 16.7474 7.41385 16.6577 7.29601C16.5679 7.17801 16.5332 7.05301 16.5537 6.92101C16.5742 6.78885 16.6434 6.67793 16.7614 6.58826L18.5344 5.25352C18.6524 5.16385 18.7774 5.12926 18.9094 5.14976C19.0416 5.17026 19.1525 5.23951 19.2422 5.35751C19.332 5.47535 19.3667 5.60035 19.3462 5.73251C19.3257 5.86451 19.2564 5.97543 19.1384 6.06526ZM5.49994 14.1535H4.46144C4.01727 14.1535 3.63702 13.9953 3.32069 13.679C3.00436 13.3627 2.84619 12.9824 2.84619 12.5383V11.4613C2.84619 11.0171 3.00436 10.6368 3.32069 10.3205C3.63702 10.0042 4.01727 9.84601 4.46144 9.84601H8.19219L10.9364 8.22677C11.2058 8.0651 11.4759 8.06302 11.7469 8.22052C12.0181 8.37802 12.1537 8.6076 12.1537 8.90927V15.0903C12.1537 15.3919 12.0181 15.6215 11.7469 15.779C11.4759 15.9365 11.2058 15.9344 10.9364 15.7728L8.19219 14.1535H6.49994V17.4613C6.49994 17.6029 6.45194 17.7217 6.35594 17.8175C6.25994 17.9133 6.14102 17.9613 5.99919 17.9613C5.85736 17.9613 5.73869 17.9133 5.64319 17.8175C5.54769 17.7217 5.49994 17.6029 5.49994 17.4613V14.1535ZM13.9229 14.8883V9.11127C14.2576 9.4216 14.5272 9.83052 14.7317 10.338C14.9362 10.8457 15.0384 11.4012 15.0384 12.0045C15.0384 12.6077 14.9362 13.1615 14.7317 13.666C14.5272 14.1705 14.2576 14.5779 13.9229 14.8883Z',
          img: '',
          preguntas: [
            {
              pregunta: 'Si tengo un reclamo ¿cómo lo puedo resolver?',
              respuesta: `<p>Para resolver tus dudas o reclamos sobre inversiones o proyectos publicados en RedCapital puedes contactarnos al correo electrónico contacto@redcapital.cl</p>`
            },
            {
              pregunta: '¿Qué hacer si no resuelven mis reclamos?',
              respuesta: `<p>Si presentas un reclamo en contacto@redcapital.cl y no tiene respuesta durante los siguientes 5 días hábiles, nos puedes contactar de Lunes a Jueves de 09:00 a 18:00, Viernes 09:00 a 17:00 en nuestro teléfono  +562 2233 3346 o dirigirte a nuestra oficina ubicada en Coronel Pereira #72, Oficina 703 - Las Condes - Región Metropolitana</p>`
            },
            {
              pregunta: '¿Cuánto tiempo pueden tardar en resolver un reclamo?',
              respuesta: `<p>El plazo máximo que tenemos para resolver tus reclamos es de 5 días hábiles. </p>`
            },
            {
              pregunta: '¿Qué hacer si mi proyecto está con mora?',
              respuesta: `
              <p>
                Las principales consultas o reclamos son por la mora. Es decir, por el plazo que pasa desde que vence la fecha original de pago hasta que recibimos la consulta del cliente (añadir gráfico de mora o tabular mora) 
              </p>
              <p>
                Es normal la mora en este tipo de operaciones: En Facturas la media de pago es 16 días de mora. Durante el periodo de mora intentaremos cobrar la máxima convencional, por lo que tu inversión podría continuar aumentando su rentabilidad.
              </p>
              `
            },
          ],
          filter: false,
        },
        {
          section: 'Token',
          slug: 'token',
          icon: 
          [
            'm9.501 4.013 5.375 3.113L8.186 11l6.69 3.874-5.375 3.115-6.035-3.496V7.506l6.035-3.493Z',
            'm10.817 11 4.717-2.73v5.463L10.817 11Z',
            'M9.501 0 0 5.5v11L9.501 22 19 16.5v-11L9.501 0Zm7.35 15.257L9.5 19.512 2.15 15.257V6.745L9.5 2.488l7.35 4.257v8.512Z'
          ],
          img: '',
          preguntas: [
            {
              pregunta: '¿Qué es un token?',
              respuesta: `<p>Un token es un activo financiero digital que representa la propiedad total o parcial de una cartera de inversiones, respaldada por activos reales.</p>`
            },
            {
              pregunta: '¿En qué se invierte cuando se compran RedCapital Token?',
              respuesta: `<p>Al comprar RedCapital Tokens se invierte en una cartera compuesta por facturas y otros activos de pequeñas y medianas empresas locales, con riesgo
                controlado y rentabilidad sostenible que han pasado por un riguroso análisis de riesgo, logrando un índice de incobrabilidad menor al 1%. 
                </p>
                <p>Con la compra de RedCapital Token, se invierte en una cartera <b>diversificada</b> de facturas asociada a empresas locales, apoyando además a cientos de Pymes que son el motor de nuestro país.</p>
                `
            },
            {
              pregunta: '¿Cuál es la inversión mínima en token?',
              respuesta: `<p>La inversión mínima es de 1 token. El precio de los tokens varía diariamente y lo puedes revisar en nuestro sitio web.</p>`
            },
            {
              pregunta: '¿Cómo se calcula el precio de los RedCapital Token?',
              respuesta: `
              <p>
               El precio de los RedCapital Tokens está relacionado a la rentabilidad de la cartera de inversiones activas gestionadas por la plataforma de inversiones y siguiendo las políticas de inversión de RedCapital. El precio varía diariamente según la rentabilidad de la cartera.
              </p>
              `
            },
            {
              pregunta: '¿Existen comisiones u otros gastos asociados a la compra de tokens?',
              respuesta: `
              <p>
                Sin comisiones ni gastos adicionales: todos los costos de invertir en RedCapital Tokens están incorporados en el precio diario del token. El precio publicado es el precio de compra final.
              </p>
              `
            },
            {
              pregunta: '¿Cómo se liquidan los token?',
              respuesta: `
              <p>
                	Los token se liquidan a través de la plataforma y en un máximo de 3 días hábiles estará el saldo disponible en la Billetera RC. El monto depositado dependerá de la cantidad de tokens liquidados y del precio vigente de los token el día de liquidación.
              </p>
              `
            },
          ],
          filter: false,
          multiplePath: true
        }
      ],
      isLoad: true,
      filters: [],
    }
  },
  computed: {
    filteredList() {
      let filteredByFilters = this.$data.faq;

      if (this.$data.filters.length > 0) {
        filteredByFilters = this.$data.faq.filter((item : Faq) => {
          return this.$data.filters.includes(item.slug);
        });
      }

      if (this.$data.search !== '') {
        const searchLower = this.$data.search.toLowerCase();
        filteredByFilters = filteredByFilters
          .map((item : Faq) => {
            const filteredPreguntas = item.preguntas.filter((pregunta) => {
              const matchesPregunta = pregunta.pregunta.toLowerCase().includes(searchLower);
              const matchesRespuesta = pregunta.respuesta.toLowerCase().includes(searchLower);
              return matchesPregunta || matchesRespuesta;
            });

            if (filteredPreguntas.length > 0) {
              return {
                ...item, 
                preguntas: filteredPreguntas,
              };
            }

            const matchesSection = item.section.toLowerCase().includes(searchLower);
            const matchesSlug = item.slug.toLowerCase().includes(searchLower);

            return matchesSection || matchesSlug
              ? { ...item, preguntas: [] } 
              : null; 
          })
          .filter((item : Faq) => item !== null);
      }

      return filteredByFilters;
    },
  },
  watch: {
    'search' (val: string) {
      if (val == null) {
        this.$data.search = ''
      } 
    },
  },
  methods:{
    filterSection(slug: string){
      this.$data.faq.forEach((item: Faq) => {
        if(item.slug === slug){
          item.filter = !item.filter;

          if(item.filter){
            this.$data.filters.push(item.slug)
          }else{
            this.$data.filters = this.$data.filters.filter((filter:string) => filter !== item.slug);
          }
        }
      });
    },
    scrollAndOpenPanel(event) {
      event.preventDefault();
      
      const element = document.getElementById('requisitos');
      if (element) {
        element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'center',
            inline: 'center' 
        });
      }
    },
    interceptarClick(event) {
      if (event.target.tagName === 'A' && event.target.getAttribute('id') !== 'goToRequisitos') {
        event.preventDefault(); 
        const ruta = event.target.getAttribute('href');
        this.$router.push(ruta); 
      }else{
        //@ts-ignore
        this.scrollAndOpenPanel(event);
      }
    },
    clearFilters(){
      this.$data.filters = [];
      this.$data.faq.forEach((item: Faq) => {
        item.filter = false;
      });
    },
  },
  updated(){
    let clickRequisitos = document.getElementById('goToRequisitos');
    if(clickRequisitos){
      //@ts-ignore
      clickRequisitos.addEventListener('click', this.scrollAndOpenPanel);
    }
  },
  components:{
    ShowLoading
  }
})
export default class NewFaq extends Vue {}
